import { interceptor, postCall } from "../../networking";
import { urls } from "../../networking/url";
import * as types from "./types/signin.types";
import * as accountTypes from "./types/account.types";
import { FETCH_SME_PROFILES_SUCCEEEDED } from "./types/onboarding.types";

export const loginUser = (data) => async (dispatch) => {
    dispatch({ type: types.LOGIN_STARTED });
    try {
        const response = await postCall(urls.loginUser, data);
        if (response.data) {
            if (response.data.isSuccessful === false) {
                if (response.data.statusCode === "k-SME-01") {
                    dispatch({
                        type: types.LOGIN_FAILED,
                        payload: "Maximum login exceeded",
                    });
                    return "Maximum login exceeded";
                } else {
                    dispatch({
                        type: types.LOGIN_FAILED,
                        payload: "Username or password is invalid",
                    });
                    return "Username or password is invalid";
                }
            } else {
                dispatch({
                    type: types.LOGIN_SUCCEDEED,
                    payload: {
                        email: data.email,
                        id: response.data.id,
                        password: data.password,
                        tokenId: response.data.tokenId,
                    },
                });
                return {
                    message: "Success",
                    email: data.email,
                    id: response.data.id,
                    tokenId: response.data.tokenId,
                };
            }
        } else {
            interceptor(response);
        }
    } catch (err) {
        dispatch({
            type: types.LOGIN_FAILED,
            payload: "Network Error",
        });
        return "Network Error";
    }
};

export const validateLoginOTP = (data) => async (dispatch) => {
    dispatch({ type: types.VALIDATE_OTP_STARTED });
    try {
        const response = await postCall(urls.validateLoginToken, data);
        const token = response.data.authResponse;
        if (response.data) {
            if (response.data.isSuccessful === false || typeof response === "undefined") {
                if (response.data.statusCode === "k-SME-15") {
                    return {
                        message: "Maximum login exceeded",
                    };
                } else {
                    dispatch({
                        type: types.VALIDATE_OTP_FAILED,
                        payload: "Validation failed",
                    });
                }
                return {
                    message: "Validation failed",
                };
            } else {
                dispatch({
                    type: types.VALIDATE_OTP_SUCCEDEED,
                    payload: {
                        email: data.email,
                        id: response.data.id,
                    },
                });
                return {
                    message: "Success",
                    email: data.email,
                    id: response.data.id,
                    token: token,
                };
            }
        } else {
            interceptor(response);
        }
    } catch (err) {
        dispatch({
            type: types.VALIDATE_OTP_FAILED,
            payload: "Network Error",
        });
        return "Network Error";
    }
};

export const ssoLoginUser = (payload) => async (dispatch) => {
    dispatch({ type: types.LOGIN_STARTED });
    try {
        const response = await postCall(urls.ssoLoginUser, payload);
        const { data } = response || {};

        if (data) {
            if (data.isSuccessful === false) {
                dispatch({
                    type: types.LOGIN_FAILED,
                    payload: data.message,
                });

                return {
                    status: false,
                    statusCode: data.statusCode,
                    message: data.message,
                };
            } else {
                dispatch({
                    type: types.LOGIN_SUCCEDEED,
                    payload: {
                        email: payload.email,
                        id: data.id,
                        password: payload.password,
                        tokens: data.data,
                        newToBankUser: false,
                    },
                });
                return {
                    status: true,
                    message: "Success",
                    email: payload.email,
                    id: data.id,
                    tokens: data.data,
                };
            }
        } else {
            interceptor(response);
        }
    } catch (err) {
        dispatch({
            type: types.LOGIN_FAILED,
            payload: "Network Error",
        });
        return { status: false, message: "Network Error", statusCode: "NE" };
    }
};

export const sendLoginValidationToken = (payload) => async (dispatch) => {
    dispatch({ type: types.SEND_LOGIN_VALIDATION_TOKEN_STARTED });
    try {
        const response = await postCall(urls.sendLoginValidationToken, payload);
        if (response?.data) {
            const { status, data } = response;
            if (status === 200) {
                if (data?.isSuccessful) {
                    dispatch({
                        type: types.SEND_LOGIN_VALIDATION_TOKEN_SUCCEEDED,
                    });
                    return {
                        status: true,
                        number: data.data,
                        message: data.message,
                    };
                } else {
                    dispatch({
                        type: types.SEND_LOGIN_VALIDATION_TOKEN_FAILED,
                        payload: "Send Token failed",
                    });
                    return {
                        status: false,
                        message: data.message,
                    };
                }
            } else {
                dispatch({
                    type: types.SEND_LOGIN_VALIDATION_TOKEN_FAILED,
                    payload: "Send Token failed",
                });
                interceptor(status, dispatch);
                return {
                    status: false,
                    message: "Sorry an error Occurred",
                };
            }
        } else {
            dispatch({
                type: types.SEND_LOGIN_VALIDATION_TOKEN_FAILED,
                payload: "Send Token failed",
            });
            interceptor(response, dispatch);
            return {
                status: true,
                message: "Sorry an error Occurred",
            };
        }
    } catch (err) {
        dispatch({
            type: types.SEND_LOGIN_VALIDATION_TOKEN_FAILED,
            payload: "Sorry, an error occurred. Please try again",
        });
        return {
            status: true,
            message: "Sorry an error Occurred",
        };
    }
};

// Utility function to handle successful dispatches
export const handleValidateLoginSuccessDispatches = (dispatch, data) => {
    const group = data?.groups?.[0];

    // Dispatch VALIDATE_OTP_SUCCEDED
    dispatch({
        type: types.VALIDATE_OTP_SUCCEDEED,
        payload: {
            email: data?.email,
            id: data?.customerId,
            data: data,
        },
    });

    // Dispatch FETCH_SME_PROFILES_SUCCEEEDED
    dispatch({
        type: FETCH_SME_PROFILES_SUCCEEEDED,
        payload: data,
    });

    // Dispatch SELECT_SME_PROFILE
    dispatch({
        type: accountTypes.SELECT_SME_PROFILE,
        payload: {
            accounts: group?.accounts?.[0],
            businessProfile: group?.businessProfile,
            nominee: group?.nominee,
            data: group,
            raw: data,
        },
    });

    // Return the data needed
    return {
        status: true,
        userID: data?.customerId,
        tokens: data?.validationResponse,
        email: data?.email,
        accountNumber: group?.accounts?.[0]?.accountNumber,
        smeProfileID: group?.businessProfile?.groupID,
        kudaBusinessTier: data.kudaBusinessTier,
        message: "Success",
        data,
    };
};

// Main validateLoginToken function
export const validateLoginToken = (payload) => async (dispatch) => {
    dispatch({ type: types.VALIDATE_OTP_STARTED });

    try {
        const response = await postCall(urls.validateLogin, payload);

        if (response?.data) {
            const { status, data } = response;

            if (status === 200 && data?.isSuccessful && data?.statusCode === "k00") {
                return handleValidateLoginSuccessDispatches(dispatch, data?.data);
            } else if (data?.statusCode === "k-SME-02") {
                return {
                    status: false,
                    message: "Token validation failed",
                };
            } else {
                dispatch({
                    type: types.VALIDATE_OTP_FAILED,
                    payload: "OTP VALIDATION FAILED",
                });
                return {
                    status: false,
                    message: "Token validation failed",
                };
            }
        } else {
            dispatch({
                type: types.VALIDATE_OTP_FAILED,
                payload: "Account Creation failed",
            });
            interceptor(response, dispatch);
            return {
                status: false,
                message: "Sorry an Error Occurred, Please try again",
            };
        }
    } catch (err) {
        dispatch({
            type: types.VALIDATE_OTP_FAILED,
            payload: "Sorry, an error occurred. Please try again",
        });
        return {
            status: false,
            message: "Sorry an Error Occurred",
        };
    }
};

export const ntbLoginUser = (payload) => async (dispatch) => {
    dispatch({ type: types.LOGIN_STARTED });
    try {
        const response = await postCall(urls.ntbLoginUser, payload);
        const { data } = response;

        if (data) {
            if (data.isSuccessful === false) {
                if (data.statusCode === "k-SME-01") {
                    dispatch({
                        type: types.LOGIN_FAILED,
                        payload: "Maximum login exceeded",
                    });
                    return "Maximum login exceeded";
                } else {
                    dispatch({
                        type: types.LOGIN_FAILED,
                        payload: "Username or password is invalid",
                    });
                    return "Username or password is invalid";
                }
            } else {
                dispatch({
                    type: types.LOGIN_SUCCEDEED,
                    payload: {
                        email: payload.email,
                        id: data.id,
                        password: payload.password,
                        tokens: data.data,
                        newToBankUser: true,
                    },
                });
                return {
                    message: "Success",
                    email: payload.email,
                    id: data.id,
                    tokens: data.data,
                };
            }
        } else {
            interceptor(response);
        }
    } catch (err) {
        dispatch({
            type: types.LOGIN_FAILED,
            payload: "Network Error",
        });
        return "Network Error";
    }
};
